export default __webpack_public_path__ + "static/media/higher_icon_phone_reversed.77325d15.svg";